export default __webpack_public_path__ + "runways_logo.4f8b89b5.png";